import withIcon from './NewIcon';
// @ts-ignore
import IconDiscovery from './icon/xl/discovery.s.svg';

export default withIcon(IconDiscovery);
